import {
    CREATE_ACCESSORY_FAIL,
    CREATE_ACCESSORY_SUCCESS,
    GET_ACCESSORY_DETAILS_FAIL,
    GET_ACCESSORY_DETAILS_SUCCESS,
    GET_ACCESSORY_DETAIL_LISTING_FAIL,
    GET_ACCESSORY_DETAIL_LISTING_SUCCESS,
    GET_ACCESSORY_LISTING_FAIL,
    GET_ACCESSORY_LISTING_SUCCESS,
    RESET_ACCESSORY_ACTION_STATE,
    RESET_ACCESSORY_STATE,
    UPDATE_ACCESSORY_FAIL,
    UPDATE_ACCESSORY_SUCCESS,
    ADD_REMARK_FAIL,
    ADD_REMARK_SUCCESS,
    TOGGLE_FEATURE_FAIL,
    TOGGLE_FEATURE_SUCCESS,
    BULK_ACTION_FAIL,
    BULK_ACTION_SUCCESS,
    BULK_DELETE_ACCESSORY_FAIL,
    BULK_DELETE_ACCESSORY_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
    accessoryListing: [],
    accessoryDetails: [],
    accessoryDetailListing: {
        inquiries: [],
        logs: [],
    },
    accessoryAdd: [],
    accessoryEdit: [],
    accessoryAddRemark: [],
    accessoryToggleFeature: [],
    accessoryBulkAction: [],
    accessoryBulkDelete: [],
    error: [],
};

const Accessory = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_ACCESSORY_LISTING_SUCCESS:
            return {
                ...state,
                accessoryListing: action.payload,
            };
        case GET_ACCESSORY_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case GET_ACCESSORY_DETAILS_SUCCESS:
            return {
                ...state,
                accessoryDetails: action.payload,
            };
        case GET_ACCESSORY_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
                accessoryDetails: action.payload,
            };

        case GET_ACCESSORY_DETAIL_LISTING_SUCCESS:
            return {
                ...state,
                accessoryDetailListing: {
                    ...state.accessoryDetailListing,
                    [action.payload.listingType]: action.payload.data,
                },
            };
        case GET_ACCESSORY_DETAIL_LISTING_FAIL:
            return {
                ...state,
                error: action.payload.error,
            };

        case CREATE_ACCESSORY_SUCCESS:
            return {
                ...state,
                accessoryAdd: action.payload,
            };
        case CREATE_ACCESSORY_FAIL:
            return {
                ...state,
                accessoryAdd: action.payload,
                error: action.payload,
            };

        case UPDATE_ACCESSORY_SUCCESS:
            return {
                ...state,
                accessoryEdit: action.payload,
            };
        case UPDATE_ACCESSORY_FAIL:
            return {
                ...state,
                accessoryEdit: action.payload,
                error: action.payload,
            };

        case ADD_REMARK_SUCCESS:
            return {
                ...state,
                accessoryAddRemark: action.payload,
            };
        case ADD_REMARK_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case TOGGLE_FEATURE_SUCCESS:
            return {
                ...state,
                accessoryToggleFeature: action.payload,
            };
        case TOGGLE_FEATURE_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case BULK_ACTION_SUCCESS:
            return {
                ...state,
                accessoryBulkAction: action.payload,
            };
        case BULK_ACTION_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case BULK_DELETE_ACCESSORY_SUCCESS:
            return {
                ...state,
                accessoryBulkDelete: action.payload,
            };
        case BULK_DELETE_ACCESSORY_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case RESET_ACCESSORY_ACTION_STATE:
            return {
                ...state,
                accessoryAdd: [],
                accessoryEdit: [],
                accessoryAddRemark: [],
                accessoryToggleFeature: [],
                accessoryBulkAction: [],
                accessoryBulkDelete: [],
                error: [],
            };
        case RESET_ACCESSORY_STATE:
            return {
                ...state,
                accessoryListing: [],
                accessoryDetails: [],
                accessoryDetailListing: {
                    inquiries: [],
                    logs: [],
                },
                accessoryAdd: [],
                accessoryEdit: [],
                accessoryAddRemark: [],
                accessoryToggleFeature: [],
                accessoryBulkAction: [],
                accessoryBulkDelete: [],
                error: [],
            };
        default:
            return state;
    }
};

export default Accessory;
